import { render, staticRenderFns } from "./ArticleClassCheckbox.vue?vue&type=template&id=493f7f90&scoped=true"
import script from "./ArticleClassCheckbox.vue?vue&type=script&lang=js"
export * from "./ArticleClassCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f7f90",
  null
  
)

export default component.exports